import { DropdownSelectionProps } from '@shared/components/DropdownButton/DropdownSelection';

import i18n from 'i18n/config';

import { Reminder } from '../CreateNewRoomDataProvider/utils';

export enum UnitsEnum {
  MINUTES = 'minutes',
  HOURS = 'hours',
  DAYS = 'days',
}

export const MINUTES_IN_UNIT = {
  [UnitsEnum.MINUTES]: 1,
  [UnitsEnum.HOURS]: 60,
  [UnitsEnum.DAYS]: 1440,
};

export const getUnitTranslation = (type: UnitsEnum, count: number, shouldDisplayCount = false) => {
  const translationProps = { count };
  const countDisplay = shouldDisplayCount ? count : '';

  switch (type) {
    case UnitsEnum.MINUTES:
      return `${countDisplay} ${i18n.t('minutes_before', translationProps)}`.trim();
    case UnitsEnum.HOURS:
      return `${countDisplay} ${i18n.t('hours_before', translationProps)}`.trim();
    case UnitsEnum.DAYS:
      return `${countDisplay} ${i18n.t('days_before', translationProps)}`.trim();
  }
};

export const getUnitSelectOptions = (
  currentCountValue: number,
  onClick: (unit: UnitsEnum) => void
): DropdownSelectionProps[] => {
  const options = [
    { title: getUnitTranslation(UnitsEnum.MINUTES, currentCountValue), onClick: () => onClick(UnitsEnum.MINUTES) },
    { title: getUnitTranslation(UnitsEnum.HOURS, currentCountValue), onClick: () => onClick(UnitsEnum.HOURS) },
    { title: getUnitTranslation(UnitsEnum.DAYS, currentCountValue), onClick: () => onClick(UnitsEnum.DAYS) },
  ];

  return options;
};

export const getCustomRemindersCount = (reminders: Reminder[]) => reminders.filter(({ isCustom }) => isCustom).length;
